import { env } from 'src/config/env';

export const getDomainUrl = (domain) => `${domain}.${env.PRD_FE_DOMAIN}`;
